<raw>
    <script>
        export default {
            // Pure presentation component - no service dependencies needed
            includeTools: false,

            setInnerHTML() {
                this.root.innerHTML = this.props.html ? this.props.html : '';
            },
            onMounted() {
                this.setInnerHTML()
            },
            onUpdated() {
                this.setInnerHTML()
            }
        }
    </script>
</raw>